import { DashboardService } from "../dashboardService";
import { LocalStorageService } from "src/services/localStorageService";
import { CreationDateSortOptions, LocalStorageKeys, UserColumnHeader } from "src/enums";
import { UsersFiltersState } from "src/types";

class UserDashService extends DashboardService<
  UserColumnHeader,
  UsersFiltersState,
  CreationDateSortOptions,
  undefined
> {
  constructor(localStorageService: LocalStorageService) {
    super(localStorageService, LocalStorageKeys.USER_ACCOUNTS_DASH_SETTINGS);
  }
}

export { UserDashService };
